import React, { useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Form, Input, Button, Row, Col } from "antd";



const isBlank = (str) => {
    return (!str || /^\s*$/.test(str));
};

const validateSearchString = (str) => {
    if (isBlank(str) === true) {
        return null;
    }

    if (isBlank(str) === false) {
        if (str === null || str === undefined) {
            return null;
        }

        return(removeSpacesFromString(str));
    }
};


const removeSpacesFromString = (str) => {
    return str.replace( /\s/g, '');
};


const rules = {
    name: [
        {
            required: true,
            message: "Ju lutem, plotësoni emrin!",
        },
    ],
    surname: [
        {
            required: true,
            message: "Ju lutem, plotësoni mbiemrin!",
        },
    ],
    father_name: [
        {
            required: true,
            message: "Ju lutem, plotësoni atësinë!",
        },
    ],
};



const Search = ({ dispatch, initialFilters, loading }) => {
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            name: initialFilters?.name,
            surname: initialFilters?.surname,
            father_name: initialFilters?.father_name,
        });
    }, [form, initialFilters]);


    const searchClickHandler = () => {
        form
            .validateFields()
            .then((data) => {
                const requestFilters = {
                    name: validateSearchString(form.getFieldValue("name")),
                    surname:  validateSearchString(form.getFieldValue("surname")),
                    father_name: validateSearchString(form.getFieldValue("father_name")),
                };

                const action = {
                    type: "set_search_filters",
                    payload: requestFilters,
                };
                dispatch(action);
            })
            .catch((err) => { });
    };


    return (
        <Form
            form={form}
            layout="vertical"
            name="advanced_search"
            className="ant-advanced-search-form"
        >
            <Row gutter={24} align="bottom">
                <Col xl={7} lg={7} md={24} sm={24} xs={24}>
                    <Form.Item name="name" label="Emri:" rules={rules.name}>
                        <Input
                            className="w-100"
                            size="medium"
                            allowClear
                        />
                    </Form.Item>
                </Col>
                <Col xl={7} lg={7} md={24} sm={24} xs={24}>
                    <Form.Item name="surname" label="Mbiemri:" rules={rules.surname}>
                        <Input
                            className="w-100"
                            size="medium"
                            allowClear
                        />
                    </Form.Item>
                </Col>
                <Col xl={7} lg={7} md={24} sm={24} xs={24}>
                    <Form.Item name="father_name" label="Atësia:">
                        <Input
                            className="w-100"
                            size="medium"
                            allowClear
                        />
                    </Form.Item>
                </Col>
                <Col xl={3} lg={3} md={24} sm={24} xs={24} className="text-center">
                    <Form.Item>
                        <Button
                            type="primary"
                            size="medium"
                            icon={<SearchOutlined />}
                            loading={loading}
                            onClick={() => searchClickHandler()}
                        >
                            Kërko
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};


export default Search;